import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { SourceOfPick } from '../betslip-base/models/pick-models';
import { BetBuilderStandardOptionGroupComponent } from './bet-builder-standard-option-group.component';
import { MarketHelpComponent } from './market-help/market-help.component';

@Component({
    selector: 'ms-bet-builder-standard-group',
    templateUrl: './bet-builder-standard-group.component.html',
    standalone: true,
    imports: [NgIf, MarketHelpComponent, BetBuilderStandardOptionGroupComponent],
})
export class BetBuilderStandardGroupComponent implements OnInit {
    @Input() event: EventModel;
    @Input() optionGroup: EventOptionGroup;
    @Input() tracking: string;
    @Input() trackingModuleType = '';
    @Input() showMarketHelp: boolean;
    @Input() eventHelpText?: string;
    @Input() sourceOfPick = SourceOfPick.Other;

    displayMultiSelectionText?: boolean = false;
    multiSelectionHelpText: string;

    constructor(public sitecore: Sitecore) {}

    ngOnInit(): void {
        if (this.sitecore.betBuilderEntainUI.messages) {
            this.multiSelectionHelpText = this.sitecore.betBuilderEntainUI?.messages?.MultiSelectionInfo;
        }

        this.displayMultiSelectionText = this.optionGroup.isMultipleSelection;
    }
}
